import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AppThemeDirective} from './app-theme.directive';

@NgModule({
  declarations: [AppThemeDirective],
  imports: [CommonModule],
  exports: [AppThemeDirective]
})
export class AppThemeModule {
}
